export default __webpack_public_path__ + "static/media/Others_0.3babcd05.svg";